import { Component, OnInit, ViewChild } from '@angular/core';
import { LoadingController, NavController, Platform } from 'ionic-angular';
import { TabPage } from '../tabpage/tabpage';
import { SearchDisplayCheck } from '../../provider/searchVisibility';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import { ConfigurationManager } from '../../provider/ConfigurationManager';
import * as Constants from '../../provider/Constants';
import { CategoryPage } from '../category/category';
import { DestinationsPage } from '../destinations/destinations';
import { TabsProviderService } from '../../provider/tabsprovider';
import { CustomSuperTabs } from '../../customviews/customchildtabs/customsupertabs';
import { CustomSuperTabsToolbar } from '../../customviews/customchildtabs/custom-supertabtoolbar';
import { CustomSuperTab } from '../../customviews/customchildtabs/customsupertab';
import { ParentCustomSuperTabsController } from '../../customviews/customparenttabs/parentcustomsupertabscontroller';
import { ParentCustomSuperTabs } from '../../customviews/customparenttabs/parentcustomsupertabs';
import { Subscription } from 'rxjs';
import { Network } from '@ionic-native/network';


/**
 * Generated class for the ParenttabsPage tabs.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'child-tabs',
  templateUrl: 'childtabs.html'
})
export class ChildtabsPage implements OnInit {

  @ViewChild('childTab') superTabs: CustomSuperTabs;
  @ViewChild(CustomSuperTabsToolbar)
  @ViewChild(ParentCustomSuperTabs) parentsuperTabs: ParentCustomSuperTabs;
  searchResultsEnable = false;
  tabsvisible = false;
  dynamictab = false;
  name;
  tabid;
  jsondata: any;
  searchparams = '';
  addedTab = false;

  tabs = [];
  sometab = TabPage;
  child = CustomSuperTab;
  title = '';
  scrollableTabsopts: any = {};
  addtabsubscription: Subscription;
  searchresultssubscription: Subscription;
  loading;
  static VACATIONSEARCH = false;
  isNetworkConnected = true;

  constructor(
    public navCtrl: NavController,
    private searchVisibleData: SearchDisplayCheck,
    private client: TabsProviderService,
    public navParams: NavParams,
    private config: ConfigurationManager,
    public loadingCtrl: LoadingController,
    private platform: Platform,
    private network: Network,
    private parentsuperTabsCtrl: ParentCustomSuperTabsController
  ) {
    this.name = this.navParams.data.name;
    this.tabid = this.navParams.data.tabid;
  }

  refreshScrollbarTabs() {
    this.scrollableTabsopts = { refresh: true };
  }


  ngOnInit(): void {
    this.searchresultssubscription = this.searchVisibleData.searchResultsMessage.subscribe(message => this.gotosearchResults(message));
    this.addtabsubscription = this.searchVisibleData.tabmesage.subscribe(message => this.addTab(message));
  }

  gotosearchResults(message) {
    if (message.searchres === true) {

      if (message.ScreenTitle === 'VACATIONS') {
        if (ChildtabsPage.VACATIONSEARCH === false) {
          ChildtabsPage.VACATIONSEARCH = true;
          this.parentsuperTabsCtrl.slideTo(Constants.VACATIONS.id);
          setTimeout(() => {
            this.searchVisibleData.changeSearchResForVacVisibility(message);
          }, 10);


        }
      } else {
        this.searchResultsEnable = true;
        this.searchparams = message;
      }

    } else {
      this.searchResultsEnable = false;
    }
  }

  ionViewDidEnter() {
    this.tabs = [];
    this.tabsvisible = false;
    const isNetworkAvailable = this.checkDeviceNetworkConnection();
      console.log('Network status '+isNetworkAvailable);
      if (!isNetworkAvailable) {
        this.removeLoader();
        this.searchResultsEnable = false;
        this.isNetworkConnected = false;
        return;
      }
    this.isNetworkConnected = true;
    console.log('after return statement');
    this.getData();
    this.presentLoading();
  }


  addTab(message) {
    if (message.ScreenTitle === this.navParams.data.name) {
      this.tabs.push({ title: message.subcatname, id: 'newtab', root: TabPage, params: message });
      this.searchVisibleData.addTab({ 'tabenable': false, 'ScreenTitle': '' });

      this.superTabs.getToolBar().ngAfterViewInit();
      setTimeout(() => {
        this.superTabs.slideTo('newtab', true);
      }, 10);
      this.addedTab = true;
    }
  }

  presentLoading() {
    this.loading = this.loadingCtrl.create({

    });

    this.loading.present();

  }

  getData() {

    if (this.name === Constants.RECOMMENDED.params.name) {
      setTimeout(() => {
        this.jsondata = this.getRecommendedSearchTypes();
        if (this.loading != null) {
          this.loading.dismiss();
        }
        for (const tempdata of this.jsondata) {
          console.log('tempdata' + tempdata.SearchTypeID);
          const tabparams = {
            'SearchTypeName': tempdata.SearchTypeName + '',
            'SearchTypeID': tempdata.SearchTypeID + '',
            'Keyword': tempdata.Keyword + '',
            'ScreenTitle': this.name + '',

          };
          const tabname: string = tempdata.SearchTypeName;
          this.tabs.push({ title: tabname.toLowerCase(), id: tempdata.SearchTypeID, root: TabPage, params: tabparams });
          this.tabsvisible = true;
        }
      }, 10);

    } else {      

      this.client.getchildTabsNative(this.name).then(data => {

        console.log('status::::' + data.status);
        console.log('data::::' + data.data); // data received by server
        console.log('data::::json' + JSON.parse(data.data));
        this.jsondata = JSON.parse(data.data);

        console.log('test' + this.jsondata[0].SearchTypeID);
        console.log('headers::::' + data.headers);

        for (const tempdata of this.jsondata) {
          console.log('tempdata' + tempdata.SearchTypeID);
          const tabparams = {
            'SearchTypeName': tempdata.SearchTypeName + '',
            'SearchTypeID': tempdata.SearchTypeID + '',
            'Keyword': tempdata.Keyword + '',
            'ScreenTitle': this.name + '',

          };

          if (tempdata.SearchTypeID === 4) {
            this.tabs.push({ title: tempdata.SearchTypeName, id: tempdata.SearchTypeID, root: CategoryPage, params: tabparams });
          } else if (tempdata.SearchTypeID === 5) {
            this.tabs.push({ title: tempdata.SearchTypeName, id: tempdata.SearchTypeID, root: DestinationsPage, params: tabparams });
          } else {
            if (this.name === Constants.VACATIONS.params.name) {
              if (tempdata.SearchTypeID !== 13) {
                this.tabs.push({ title: tempdata.SearchTypeName, id: tempdata.SearchTypeID, root: TabPage, params: tabparams });
              }
            } else {
              this.tabs.push({ title: tempdata.SearchTypeName, id: tempdata.SearchTypeID, root: TabPage, params: tabparams });
            }
          }
        }
        if (this.name === Constants.VACATIONS.params.name) {
          const vacationdata = this.getVacationsTypes();
          for (const vdata of vacationdata) {
            const tabparams = {
              'SearchTypeName': vdata.SearchTypeName + '',
              'SearchTypeID': vdata.SearchTypeID + '',
              'Keyword': vdata.Keyword + '',
              'ScreenTitle': this.name + '',

            };
            if (vdata.SearchTypeID === 16 || vdata.SearchTypeID === 17) {
              this.tabs.push({ title: vdata.SearchTypeName, id: vdata.SearchTypeID, root: DestinationsPage, params: tabparams });
            } else {
              this.tabs.push({ title: vdata.SearchTypeName, id: vdata.SearchTypeID, root: TabPage, params: tabparams });
            }
          }
        }
        if (this.loading != null) {
          this.loading.dismiss();
        }
        this.tabsvisible = true;
        console.log('this tabs::::' + this.tabs.length); // data received by server


      })
        .catch(error => {

          console.log(error.status);
          console.log(error.error); // error message as string
          console.log(error.headers);
          if (this.loading != null) {
            this.loading.dismiss();
          }

        });
    }

  }

  getVacationsTypes(): any {

    const data = [];
    data.push({ 'SearchTypeName': Constants.cruise_vacations, 'SearchTypeID': 16, 'Keyword': '' });
    data.push({ 'SearchTypeName': Constants.tour_vacations, 'SearchTypeID': 17, 'Keyword': '' });
    data.push({ 'SearchTypeName': Constants.attractions_and_events, 'SearchTypeID': 4, 'Keyword': '' });

    return data;
  }

  getRecommendedSearchTypes(): any {
    const data = [];
    data.push({ 'SearchTypeName': Constants.RECOMMENDED.params.name, 'SearchTypeID': 12, 'Keyword': '' });
    data.push({ 'SearchTypeName': Constants.LOCAL.params.name, 'SearchTypeID': 10, 'Keyword': '' });
    data.push({ 'SearchTypeName': Constants.most_popular, 'SearchTypeID': 11, 'Keyword': '' });
    if (this.config.getAuthinticated) {
      data.push({ 'SearchTypeName': Constants.browsing_history, 'SearchTypeID': 3, 'Keyword': '' });
    }
    return data;
  }


  ionViewDidLeave() {
    console.log('View will Leave');
    /*  if(this.addedTab == true){
       setTimeout(() => {
         this.superTabs.popTab();
         this.tabs.pop();
        // this.superTabs.getToolBar().ngAfterViewInit();
         this.addedTab =false;
       }, 10);
     } */
    this.tabs = [];

  }

  ngOnDestroy() {
    console.log('Child tabs ondestroy');
    this.searchresultssubscription.unsubscribe();
    this.addtabsubscription.unsubscribe();
  }
  receiveMessage($event) {
    // this.isVisible = $event
  }

  swipeEvent(e) {
    console.log('swiped');
  }

  removeTab() {
    if (this.addedTab === true) {
      for (const tab of this.tabs) {

        if (tab.id === 'newtab') {
          setTimeout(() => {
            this.superTabs.popTab();
            this.tabs.pop();
            this.superTabs.getToolBar().ngAfterViewInit();
            this.addedTab = false;
          }, 10);
        }
      }
    }
  }

  onTabSelect(ev: any) {
    console.log('Tab selected pp', 'Index: ' + ev.index, 'Unique ID: ' + ev.id);
    if (ev.id !== 'newtab') {
      this.removeTab();
    }
    this.searchVisibleData.changeSearchResVisibility({ 'searchres': false });
  }

  checkDeviceNetworkConnection():boolean {
    if (this.platform.is('cordova')) {
      const isNetworkAvailable = (this.network.type === 'none') ? false : true;
      return isNetworkAvailable;
    }
  }

  removeLoader() {
    if (this.loading != null) {
      this.loading.dismiss();
    }
  }
}
